module.exports = __webpack_public_path__ + "static/media/blog-2.e87a48dd.svg";